import {useRef} from 'react';

import {SimpleGrid} from '@mantine/core';
import {useNavigate} from 'react-router-dom';

import {useReconciliationReports} from '../hooks/useReconciliationReports.ts';
import {useTableColumns} from '../hooks/useTableColumns.tsx';

import {MantineDataTable,
    DataTableTokenPagination,
} from '@flexinet/ui-components';

export const RecordsTable = () => {
    const {columns} = useTableColumns();
    const navigate = useNavigate();

    const {
        items,
        totalCount,
        loading,
        nextToken,
        fetchRecords,
    } = useReconciliationReports();

    const scrollViewportRef = useRef<HTMLDivElement>(null);

    // Read-only (FNP-535): no selection / no edit drawer. Row click opens the detail
    // view. The ReconciliationReport id is a COMPOSITE key
    // (`reconciliation-report:{channel}#{runDate}`) containing `:` and `#`, so it MUST
    // be encodeURIComponent'd before going into the path — otherwise the `#` would be
    // read as a URL fragment delimiter, the path would truncate, useParams().id would
    // come back partial, and getReconciliationReport(<partial id>) returns nothing →
    // the detail page hangs on its loading spinner forever. react-router v6 useParams()
    // auto-decodes, so the detail page receives the original id. (Same composite-id
    // rule as the sibling observability modules FNP-533/534/585.)
    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <MantineDataTable
                columns={columns}
                records={items}
                fetching={loading}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
                onRowClick={({record}) => navigate(`/reconciliation-reports/${encodeURIComponent(record.id)}`)}
            />

            <DataTableTokenPagination loadedCount={totalCount} nextToken={nextToken}
                                      handleLoadMore={fetchRecords}/>
        </SimpleGrid>
    );
};
